import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { Image, Text, Title } from "../../ui";

import Fire from "../../../assets/images/fire.png";
import Water from "../../../assets/images/water.png";
import Wind from "../../../assets/images/wind.png";
import Plant from "../../../assets/images/plant.png";
import { Flex, SafeArea } from "../../layout";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer>
      <SafeArea>
        <Flex type="col" gap={80}>
          <Flex type="between-center" className="ctn-text" wrap gap={30}>
            <Flex type="col" gap={5} className="left">
              <Title level="h3">L'Ecrin Sauvage</Title>
              <Text size="xs">
                Tous droits réservés &copy; {year} <br />
                Réalisé par <a href="//loukaaa.com">loukaaa.com</a>
              </Text>
            </Flex>
            <Flex gap={50} className="right" wrap>
              <Flex type="col" gap={5}>
                <Title level="h4">Légales</Title>
                <Link to="/legal/mentions">Mentions</Link>
                <Link to="/legal/cookies">Cookies</Link>
              </Flex>
              <Flex type="col" gap={5}>
                <Title level="h4">Contact</Title>
                <a href="mailto:contact@lecrin-sauvage.fr">
                  contact@lecrin-sauvage.fr
                </a>
                <a href="tel:+33673989646">+33 6 73 98 96 46</a>
              </Flex>
            </Flex>
          </Flex>
          <Link to="/elements">
            <Flex type="center" gap={50} className="ctn-images" wrap>
              <Link to="/elements/feu">
                <Flex type="col-center" gap={15}>
                  <Image src={Fire} alt="" />
                  <Text>Feu</Text>
                </Flex>
              </Link>
              <Link to="/elements/eau">
                <Flex type="col-center" gap={15}>
                  <Image src={Water} alt="" />
                  <Text>Eau</Text>
                </Flex>
              </Link>
              <Link to="/elements/air">
                <Flex type="col-center" gap={15}>
                  <Image src={Wind} alt="" />
                  <Text>Air</Text>
                </Flex>
              </Link>
              <Link to="/elements/terre">
                <Flex type="col-center" gap={15}>
                  <Image src={Plant} alt="" />
                  <Text>Terre</Text>
                </Flex>
              </Link>
            </Flex>
          </Link>
        </Flex>
      </SafeArea>
    </footer>
  );
}

export default Footer;
